import type { AppRouter } from '@foodlista/backend'
import type { RouterClient } from '@orpc/server'
import { defineNuxtPlugin } from '#app'
import { createORPCClient } from '@orpc/client'
import { RPCLink } from '@orpc/client/fetch'

export default defineNuxtPlugin(() => {
  const { backendUrl, proxyBackend, siteUrl } = useRuntimeConfig().public
  const nuxtApp = useNuxtApp()

  const link = new RPCLink({
    url: `${proxyBackend ? siteUrl : backendUrl}/rpc`,
    headers: () => ({
      'accept-language': nuxtApp.$i18n.locale.value,
    }),
    fetch: (request, init) =>
      globalThis.fetch(request, {
        ...init,
        credentials: 'include',
      }),
  })

  const orpc: RouterClient<AppRouter> = createORPCClient(link)

  return {
    provide: {
      orpc,
    },
  }
})
